import { lazy } from 'react';
export const BatchSMS = lazy(() => import('@/Portal/BatchSMS/BatchSMS'));
export const CreateBatchSMS = lazy(() => import('@/Portal/BatchSMS/CreateBatchSMS'));
export const ViewInstance = lazy(() => import('@/Portal/BatchSMS/ViewInstance'));
